/*
 * This helper script updates the shipping hour notice in product page.
 * It takes in a callback function that updates the shipping notice state.
 */
// Set permanent shipping hour
const shipmentNoticeSetter = setShippingHours => {
  const shippingHour = 12

  const shippingMessageSetter = (diff, day) =>
    `in the next ${diff} to ship ${day}`

  // Refactor legacy shipment time setter code
  // Initialize times
  const today = new Date()
  const currentTime = today.getHours()
  const currentDay = today.getDay()
  // Initialize variables
  let day
  let hourDifference
  let minutesDiff
  let hourDiffMsg
  let minuteDiffMsg
  let hoursToday
  let hoursLeft

  // Define cases
  if (currentDay >= 1 && currentDay <= 4) {
    day = "weekday"
  } else if (currentDay === 5) {
    day = "friday"
  } else if (currentDay === 6) {
    day = "saturday"
  } else if (currentDay === 0) {
    day = "sunday"
  }

  switch (day) {
    case "weekday":
      hourDifference = shippingHour - currentTime

      if (hourDifference > 1) {
        hourDiffMsg = `${hourDifference} hour(s)`
        setShippingHours(shippingMessageSetter(hourDiffMsg, "today"))
      } else if (hourDifference === 1) {
        minutesDiff = 60 - today.getMinutes()
        minuteDiffMsg = `${minutesDiff} minutes(s)`
        setShippingHours(shippingMessageSetter(minuteDiffMsg, "today"))
      } else {
        hourDifference = 24 - currentTime
        hourDiffMsg = `${hourDifference} hour(s)`
        setShippingHours(shippingMessageSetter(hourDiffMsg, "tomorrow"))
      }
      break
    case "friday":
      hourDifference = shippingHour - currentTime
      hourDiffMsg = `${hourDifference} hour(s)`

      if (hourDifference > 1) {
        setShippingHours(shippingMessageSetter(hourDiffMsg, "today"))
      } else if (hourDifference === 1) {
        minutesDiff = 60 - today.getMinutes()
        minuteDiffMsg = `${minutesDiff} minutes(s)`
        setShippingHours(shippingMessageSetter(minuteDiffMsg, "today"))
      } else {
        // How many hours left to wait today
        hoursToday = 24 - currentTime

        hourDifference = hoursToday + 48
        hourDiffMsg = `${hourDifference} hour(s)`

        setShippingHours(shippingMessageSetter(hourDiffMsg, "Monday"))
      }
      break
    case "saturday":
      hoursToday = 24 - currentTime

      hourDifference = hoursToday + 24
      hourDiffMsg = `${hourDifference} hour(s)`

      setShippingHours(shippingMessageSetter(hourDiffMsg, "Monday"))
      break
    case "sunday":
      hoursLeft = 24 - currentTime

      hourDiffMsg = `${hoursLeft} hour(s)`

      shippingMessageSetter(hourDiffMsg, "tomorrow")
      break
    default:
      shippingMessageSetter("0 hour", "tomorrow")
  }

  // don't ship on weekends
  // if (currentDay == 0 || currentDay == 6) return;

  // let hourDifference = time - currentTime;
  //
  // if (hourDifference >= 1) setShippingHours(shippingMessageSetter(hourDifference));
}
// don't ship on weekends
// if (currentDay == 0 || currentDay == 6) return;

// let hourDifference = time - currentTime;
//
// if (hourDifference >= 1) setShippingHours(shippingMessageSetter(hourDifference));

export default shipmentNoticeSetter
